import React, { Component } from "react";
import { connect } from "react-redux";
import { actions as toCollegeToolActions } from "../../../redux/modules/tocollagetool";
import { actions as schoolFilterActions } from "../../../redux/modules/schoolfilter";
import { get, post } from "../../../utils/request";
import ToCollageToolFilterHeader from "../ToCollageToolFilter/components/ToCollageToolFilterHeader";
import ToCollageToolFilterMajor from "../ToCollageToolFilter/components/ToCollageToolFilterMajor";
import ToCollageSchoolFilter from "../ToCollageToolFilter/components/ToCollageSchoolFilter";
import InfoModal from "../../../components/InfoModal";
import { jumpUrl } from "../../../utils/tool";
import "./style.css";
import "../../../index.css";
class ToCollageToolFilter extends Component {
  componentDidMount() {
    this.requestUserCondition();
    this.requestSchoolFilter();
    this.requestUserData();
    this.requestIsBuy();
  }
  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(schoolFilterActions.setLevelFilterId([]));
    dispatch(schoolFilterActions.setTagFilterId([]));
    dispatch(schoolFilterActions.setPropertyFilterId([]));
    dispatch(schoolFilterActions.setProvinceFilterId([]));
    dispatch(schoolFilterActions.setLevelMarkArray([]));
    dispatch(schoolFilterActions.setTagMarkArray([]));
    dispatch(schoolFilterActions.setPropertyMarkArray([]));
    dispatch(schoolFilterActions.setProvinceMarkArray([]));
  }
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      filterVisible: false,
      filterData: null,
      params: {
        schoolName: "",
        schoolLevelIds: [],
        schoolTagIds: [],
        schoolPropertyIds: [],
        provinceIds: [],
        pageNum: 1,
        pageSize: 20,
      },
      cNum: 0,
      dNum: 0,
      userCData: [],
      userDData: [],
    };
  }
  render() {
    const { subjectCondition, wholeSubject, totalScore, uiState } = this.props;
    const { filterVisible, filterData, cNum, dNum, userCData, userDData } =
      this.state;
    return (
      <div>
        <ToCollageSchoolFilter
          visible={filterVisible}
          filterData={filterData}
          handleVisibleFilter={this.handleVisibleFilter}
          requestUserData={this.requestUserData}
        ></ToCollageSchoolFilter>
        <ToCollageToolFilterHeader
          totalScore={totalScore}
          wholeSubject={wholeSubject}
          subjectCondition={subjectCondition}
          handleVisibleFilter={this.handleVisibleFilter}
          exportExcel={this.exportExcel}
          open={this.handleOpen}
        ></ToCollageToolFilterHeader>
        <div className="to_collage_tool_filter_line"></div>
        <ToCollageToolFilterMajor
          cNum={cNum}
          dNum={dNum}
          userCData={userCData}
          userDData={userDData}
          requestUserData={this.requestUserData}
        ></ToCollageToolFilterMajor>
        <InfoModal
          visible={uiState.infoVisible}
          info={uiState.info}
          close={this.handleClose}
        ></InfoModal>
      </div>
    );
  }

  /**
   * 打开信息框
   */
  handleOpen = () => {
    const { dispatch } = this.props;
    dispatch(toCollegeToolActions.setInfoVisible(true));
  };

  /**
   * 关闭信息框
   */
  handleClose = () => {
    const { dispatch } = this.props;
    dispatch(toCollegeToolActions.setInfoVisible(false));
  };

  /**
   *控制侧边栏条件过滤框的关闭和展示
   */
  handleVisibleFilter = () => {
    this.setState({
      ...this.state,
      filterVisible: !this.state.filterVisible,
    });
  };

  /**
   * 请求院校的过滤条件
   */
  requestSchoolFilter() {
    get("/public/v1/school/filter/0").then((res) => {
      this.setState({
        filterData: res.data,
      });
    });
  }
  /**
   * 获取用户是否购买的标识
   */
  requestIsBuy = () => {
    get("/public/v1/user/isBuy").then((res) => {
      if (res.data === false) {
        jumpUrl("pay");
      }
    });
  };

  /**
   * 请求用户条件
   */
  requestUserCondition = () => {
    const { dispatch } = this.props;
    get("/public/v1/toCollage/condition").then((res) => {
      let majorCondition = JSON.parse(JSON.stringify(res.data.majorCondition));
      let scoreCondition = JSON.parse(JSON.stringify(res.data.scoreCondition));
      let subjectCondition = JSON.parse(
        JSON.stringify(res.data.subjectCondition)
      );
      let totalScore = JSON.parse(JSON.stringify(res.data.totalScore));
      let subjectScore = this.props.subjectScore;
      for (let i = 0; i < scoreCondition.length; i++) {
        subjectScore[scoreCondition[i].subject] = scoreCondition[i].score;
      }
      let preSubjectScore = JSON.parse(JSON.stringify(subjectScore));
      dispatch(toCollegeToolActions.setScoreCondition(scoreCondition));
      dispatch(toCollegeToolActions.setPreSubjectScore(preSubjectScore));
      dispatch(toCollegeToolActions.setSubjectCondition(subjectCondition));
      dispatch(toCollegeToolActions.setTotalScore(totalScore));
      dispatch(toCollegeToolActions.setMajorCondition(majorCondition));
    });
  };

  requestUserData = () => {
    let params = {
      levelFilterId: this.props.schoolFilter.levelFilterId,
      propertyFilterId: this.props.schoolFilter.propertyFilterId,
      provinceFilterId: this.props.schoolFilter.provinceFilterId,
      tagFilterId: this.props.schoolFilter.tagFilterId,
    };
    post("/public/v1/toCollage/user/data", params).then((res) => {
      let data = res.data;
      this.setState({
        userDData: data.toCollageVDataD,
        userCData: data.toCollageVDataC,
        cNum: data.toCollageVDataC.length,
        dNum: data.toCollageVDataD.length,
      });
    });
  };

  exportExcel = () => {
    let req = {
      levelFilterId: this.props.schoolFilter.levelFilterId,
      propertyFilterId: this.props.schoolFilter.propertyFilterId,
      provinceFilterId: this.props.schoolFilter.provinceFilterId,
      tagFilterId: this.props.schoolFilter.tagFilterId,
    };
    console.log(req);
    let fileName = "";
    fetch("/public/v1/toCollage/excel/export", {
      method: "POST",
      responseType: "blob",
      body: JSON.stringify(req),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        fileName = res.headers
          .get("Content-Disposition")
          .split(";")[1]
          .split("=")[1];
        return res.blob();
      })
      .then((blob) => {
        new Blob([blob], {
          type: "application/vnd.ms-excel",
        });
        fileName = fileName.replace(".xls", "") + "候选志愿" + ".xls";
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      });
  };
}

const mapStateToProps = (state) => {
  return {
    uiState: state.toCollageTool.toCollageUIData,
    userInfo: state.user.userData.userInfo,
    subjectCondition: state.toCollageTool.toCollageData.subjectCondition,
    wholeSubject: state.toCollageTool.toCollageData.wholeSubject,
    totalScore: state.toCollageTool.toCollageData.totalScore,
    majorCondition: state.toCollageTool.toCollageData.majorCondition,
    subjectScore: state.toCollageTool.toCollageData.subjectScore,
    schoolFilter: state.schoolfilter.schoolFilterData,
  };
};

export default connect(mapStateToProps)(ToCollageToolFilter);



// WEBPACK FOOTER //
// ./src/containers/ToCollegeTool/ToCollageToolFilter/index.js